/**
 * Calls onRemoved when the node passed in is removed from the DOM, except if the DOM node
 * has no parent.
 *
 * If node has no parent, this is a no-op.
 *
 * @param node the observed node
 * @param onRemoved a callback called when the node passed in is removed.
 * Passes in the mutation observer that triggered the removal.
 */
export default function onDomRemoval(
  node: Node,
  onRemoved: (observer: MutationObserver) => void
): void {
  if (node.parentElement) {
    const mutationObserver = new MutationObserver((mutations, observer) => {
      for (const mutation of mutations) {
        mutation.removedNodes.forEach((removedNode) => {
          if (removedNode === node) {
            onRemoved(observer);
          }
        });
      }
    });
    mutationObserver.observe(node.parentElement, {
      childList: true,
    });
  }
}
